import moment from 'moment'
import {
  MALDIVES_CHARTER_START_TARGET_DATE,
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
} from 'constants/charterFlight'

export function getDayOfWeekAtLeastOneWeekAway(dayOfWeek: number): moment.Moment {
  const startTargetedDate = moment(MALDIVES_CHARTER_START_TARGET_DATE).startOf('day')
  const baseDate = moment.max(moment().add(1, 'week').startOf('day'), startTargetedDate)

  const initialDOW = baseDate.day()
  // Use positive modulo to ensure we always move forward
  const diff = ((dayOfWeek - initialDOW) % 7 + 7) % 7
  return baseDate.clone().add(diff, 'days')
}

export {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}
